import React from 'react';


import './index.css';

import {Navbar} from "./Navbar"
import Home from './home';

import img4 from './Images/canteen desk.jpg';
import img1 from './Images/newz.jpg';
import img2 from './Images/blog.jpg';
import img3 from './Images/land.jpg';
import img5 from './Images/11.jpg';
import img6 from './Images/12.jpg';
import img7 from './Images/13.jpg';
import img8 from './Images/99.jpeg';
import img9 from './Images/kunal.jpg';
import img10 from './Images/mix.jpg';
import img11 from './Images/trees.jpg';
import img12 from './Images/farmer.jpg';
import img13 from './Images/81.jpg';
import img14 from './Images/agm.jpg';
import img15 from './Images/SMP.jpg';
import img16 from './Images/3p.jpg';
import img17 from './Images/1p.jpg';
import img18 from './Images/2p.jpg';
import img19 from './Images/india.jpg';
import img20 from './Images/farm.jpg';
import img21 from './Images/trie.jpg';
import img22 from './Images/loggo.png';
import img23 from './Images/dw.png';
function App(){

  return (
    <>
   <div>
    <Navbar/>
    <div id="carouselExampleCaptions" class="carousel slide wide" data-bs-ride="carousel">
  <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src={img5} class="img-fluid ll"/>
      <div class="carousel-caption d-none d-md-block">
        <h5>First slide label</h5>
        <p>Some representative placeholder content for the first slide.</p>
      </div>
    </div>
    
    <div class="carousel-item">
      <img src={img6} class="img-fluid" alt="..."/>
      <div class="carousel-caption d-none d-md-block">
        <h5>Third slide label</h5>
        <p>Some representative placeholder content for the third slide.</p>
      </div>
    </div>
    <div class="carousel-item">
      <img src={img7} class="img-fluid" alt="..."/>
      <div class="carousel-caption d-none d-md-block">
        <h5>Third slide label</h5>
        <p>Some representative placeholder content for the third slide.</p>
      </div>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
<div id="carouselExampleCaptions5" class="carousel slide narrow" data-bs-ride="carousel">
  <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleCaptions5" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions5" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions5" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src={img16} class="img-fluid ll"/>
      <div class="carousel-caption d-none d-md-block">
        <h5>First slide label</h5>
        <p>Some representative placeholder content for the first slide.</p>
      </div>
    </div>
    
    <div class="carousel-item">
      <img src={img17} class="img-fluid" alt="..."/>
      <div class="carousel-caption d-none d-md-block">
        <h5>Third slide label</h5>
        <p>Some representative placeholder content for the third slide.</p>
      </div>
    </div>
    <div class="carousel-item">
      <img src={img18} class="img-fluid" alt="..."/>
      <div class="carousel-caption d-none d-md-block">
        <h5>Third slide label</h5>
        <p>Some representative placeholder content for the third slide.</p>
      </div>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions5" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions5" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
    <div className='lonks'>
      <div className='lonk'><a>Grocery</a></div>
      <div className='lonk'>Soil Testing</div>
      <div className='lonk'>Agri Input</div>
      <div className='lonk'>Agri Finance</div>
      <div className='lonk'>Advisory</div>
      <div className='lonk'>Equipments</div>
      <div className='lonk a1'>Farm Intelligence</div>
      <div className='lonk a2'>Agri Trade</div>

    </div>
    <div className="App xd" data-aos="slide-up">
      
      <div className='ad container grow'>
      
              
              <img src={img10} className='zz'/>
              <div className='bottom-leftt'>#Tomorrow's Agri Giant</div>
              <div class="bottom-left">OUR FUTURE<span>&#129141;</span></div>
      </div>
      <div className='bd container grow'>
      
              
              <img src={img13} className='zz'/>
              <div className='bottom-leftt'>Complete Umbrella Is Yet To Come</div>
              <div class="bottom-left">ANNOUCEMENT<span>&#129141;</span></div>
      </div>
      <div className='cd container grow'>
      
              
              <img src={img9} className='zz'/>
              <div className='bottom-leftt'>#We Make Farmers Happy</div>
              <div class="bottom-left">OUR IMPACT<span>&#129141;</span></div>
      </div>   
  </div>
  </div>
  <div id='carouselExampleCaptions2' className="carousel slide rf wide" data-aos='fade' data-bs-ride="carousel">
  <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleCaptions2" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions2" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions2" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src={img3} class="img-fluid"/>
      <div class="bottom-lefto">5000 Blocks Covered <br/>By 2030<span>&#129141;</span></div>
    </div>
    
    <div class="carousel-item">
      <img src={img12} class="img-fluid" alt="..."/>
      <div class="bottom-lefto">5Mn Farmers covered by 2030</div>
    </div>
    <div class="carousel-item">
      <img src={img11} class="img-fluid" alt="..."/>
      <div class="bottom-lefto">One Million Trees Will Be Planted<br/> By 2027<span>&#129141;</span></div>
      </div>
    
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions2" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions2" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
<div id='carouselExampleCaptions6' className="carousel slide rf narrow" data-aos='fade' data-bs-ride="carousel">
  <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleCaptions6" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions6" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions6" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src={img19} class="img-fluid"/>
      <div class="bottom-lefto">5000 Blocks Covered <br/>By 2030<span>&#129141;</span></div>
    </div>
    
    <div class="carousel-item">
      <img src={img20} class="img-fluid" alt="..."/>
      <div class="bottom-lefto">5Mn Farmers covered by 2030</div>
    </div>
    <div class="carousel-item">
      <img src={img21} class="img-fluid" alt="..."/>
      <div class="bottom-lefto">One Million Trees Will Be Planted<br/> By 2027<span>&#129141;</span></div>
      </div>
    
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions6" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions6" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
<div id='carouselExampleCaptions3' className="carousel slide rf" data-aos='fade' data-bs-ride="carousel">
  <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleCaptions3" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions3" data-bs-slide-to="1" aria-label="Slide 2"></button>
    
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
    <div className="App xd" data-aos="slide-up">
      
      <div className='ad container grow'>
      
              
              <img src={img10} className='zz'/>
              <div className='bottom-leftt'>#Be part of the next agri revolution</div>
              <div class="bottom-left">Carrer<span>&#129141;</span></div>
      </div>
      <div className='bd container grow'>
      
              
              <img src={img2} className='zz'/>
              <div className='bottom-leftt'>#Story Of The Real India</div>
              <div class="bottom-left">Kisan Ki BaAt<span>&#129141;</span></div>
      </div>
      <div className='cd container grow'>
      
              
              <img src={img1} className='zz'/>
              <div className='bottom-leftt'>Headline</div>
              <div class="bottom-left">In The News<span>&#129141;</span></div>
      </div>   
  </div>
      
    </div>
    
    <div className='carousel-item'>
    <div className="App xd" data-aos="slide-up">
      
      <div className='ad container grow'>
      
              
              <img src={img14} className='zz'/>
              <div className='bottom-leftt'>Headline</div>
              <div class="bottom-left">Press Release<span>&#129141;</span></div>
      </div>
      <div className='bd container grow'>
      
              
              <img src={img15} className='zz'/>
              <div className='bottom-leftt'>#Connect To The Real India</div>
              <div class="bottom-left">Social Media<span>&#129141;</span></div>
      </div>
      <div className='cd container grow'>
      
              
              <img src={img8} className='zz'/>
              <div className='bottom-leftt'>Baluster Of Our Milestone</div>
              <div class="bottom-left">Our Partner<span>&#129141;</span></div>
      </div>   
  </div>
      
    </div>
    
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions3" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions3" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
  
  <div>
    <img src={img4} className='ql'/>
    </div> 
    
    <footer>
      <div className='footer'>
        <div className='bb'>
          <img src={img22} className='f-image'/>
          
        </div>
        <div className='f-text'>
            Rabaltoj Agri
        </div>
        
        <div className='f-texxt'>
        
        </div>
      </div>
    </footer>

        
  </>
   
   
   
   
    
   
  );
}

export default App;
